import { httpPost } from '../http';
import Session from '../../CheckoutSession';
import { API_ERROR_CODE, API_VERSION } from './constants';
import { CheckoutSessionDonationCampaignsResponse } from '../../CheckoutSession/types';

/**
 */
function fetchDonationCampaigns(session: Session): Promise<CheckoutSessionDonationCampaignsResponse> {
    const path = `${API_VERSION}/sessions/${session.id}/donationCampaigns?clientKey=${session.clientKey}`;
    const data = {
        ...(session.data && { sessionData: session.data })
    };

    return httpPost({ loadingContext: session.loadingContext, path, errorLevel: 'fatal', errorCode: API_ERROR_CODE.donationCampaigns }, data);
}

export default fetchDonationCampaigns;
